import { c as _c } from "react/compiler-runtime";
export default function CheckIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span aria-hidden="true" className="mask-icon mask-icon-check" style={{
      width: "1.5rem",
      height: "1.5rem",
      backgroundColor: "#008254",
      marginRight: "0.25rem"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}